import * as React from "react";
import Modal from "react-responsive-modal";
import "./MergeCustomerModal.css";

interface Props {
    onClose: Function;
}

interface State {
    isModalOpen: boolean;
    quoteId: number;
    customerId: number;
}

export default class MergeCustomerModal extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            isModalOpen: false,
            quoteId: 0,
            customerId: 0,
        };

        this.handleClose = this.handleClose.bind(this);
        this.handleQuoteIdChanged = this.handleQuoteIdChanged.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    public render() {
        return <Modal open={this.state.isModalOpen} onClose={this.handleClose} little classNames={{ overlay: "modal-overlay" }} closeOnOverlayClick={false}>
            <form onSubmit={this.handleSubmit}>
                <p>Enter Quote ID of the quote the customer will be moved to.</p>
                <input type="text" className="form-control" onChange={this.handleQuoteIdChanged} />
                <div className="button-actions text-center">
                    <input type="submit" className="btn btn-primary" value="Submit" />
                    <input type="button" className="btn-link" value="Cancel" onClick={this.handleClose} />
                </div>
            </form>
        </Modal>;
    }

    handleClose() {
        this.setState({
            isModalOpen: false,
        });

        this.props.onClose({
            quoteId: 0,
            customerId: 0,
        });
    }

    handleQuoteIdChanged(event: React.FormEvent<HTMLInputElement>) {
        this.setState({
            quoteId: parseInt(event.currentTarget.value, 10) || 0,
        });
    }

    handleSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();

        this.setState({
            isModalOpen: false,
        });

        this.props.onClose({
            quoteId: this.state.quoteId,
            customerId: this.state.customerId,
        });
    }
}


// WEBPACK FOOTER //
// ./ClientApp/components/common/MergeCustomerModal.tsx